import "./rlearn.css"
export default function Rlearn() {
        
    return(<div>

        <div  class="lheadr">
            <h1>Things I have learn in DS & ML</h1>
        </div>
    
    <div class="mainlearnr">
        
        <div class="learnr">
            <h2>Data Science</h2>
            <ul>
                <li>hiii</li>
                <li>hiii</li>
                <li>hiii</li>
            </ul>
        </div>
        <div class="learnr">
            <h2>Machine Learning</h2>
            <ul>
                <li>hiii</li>
                <li>hiii</li>
                <li>hiii</li>
            </ul>
        </div>
    </div>
    </div>
    )
}